// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-phases-fair_play-drop-down__container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.tournament-phases-fair_play-drop-down__container .MuiFormControl-root {
    min-width: 350px;
    margin: 16px 16px 24px 16px;
    border: 1px solid var(--new-gray-color);
    padding: 0 var(--space-half-quarter);
    border-radius: var(--space-quarter);
    min-height: 42px;
}

.tournament-phases-fair_play-drop-down__container .MuiInput-underline:before,
.tournament-phases-fair_play-drop-down__container .MuiInput-underline:hover:not(.Mui-disabled):before {
    border-bottom: none;
}


.tournament-phases-fair_play-drop-down__container .MuiInputBase-root {
    font-family: var(--secondary-font);
    font-weight: var(--font-medium);
    font-size: calc(var(--space) + var(--space-eighth) + 1px);
    line-height: calc(var(--space) + var(--space-quarter) + var(--space-eighth));
}

.tournament-phases-fair_play-drop-down__container .MuiSelect-select.MuiInputBase-input.MuiInput-input {
    padding-left: 0;
    padding-top: 0;
    padding-bottom: 0;
}

.tournament-phases-fair_play-drop-down__container .MuiTypography-root {
    font-weight: var(--font-medium);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .tournament-phases-fair_play-drop-down__container {
        background: var(--white-color);
    }

    .tournament-phases-fair_play-drop-down__container .MuiFormControl-root {
        width: 100%;
        margin: 12px 10px;
    }
    
    #menu-tournament-phases-fair_play-drop-down__select .MuiPaper-root {
        left: 12px !important;
    }

    .tournament-phases-fair_play-drop-down__container .MuiFormControl-root {
        border-radius: 8px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-phases-fair-play-drop-down/TournamentPhasesFairPlayDropDownComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,uCAAuC;IACvC,oCAAoC;IACpC,mCAAmC;IACnC,gBAAgB;AACpB;;AAEA;;IAEI,mBAAmB;AACvB;;;AAGA;IACI,kCAAkC;IAClC,+BAA+B;IAC/B,yDAAyD;IACzD,4EAA4E;AAChF;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;AACnC;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,8BAA8B;IAClC;;IAEA;QACI,WAAW;QACX,iBAAiB;IACrB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".tournament-phases-fair_play-drop-down__container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.tournament-phases-fair_play-drop-down__container .MuiFormControl-root {\n    min-width: 350px;\n    margin: 16px 16px 24px 16px;\n    border: 1px solid var(--new-gray-color);\n    padding: 0 var(--space-half-quarter);\n    border-radius: var(--space-quarter);\n    min-height: 42px;\n}\n\n.tournament-phases-fair_play-drop-down__container .MuiInput-underline:before,\n.tournament-phases-fair_play-drop-down__container .MuiInput-underline:hover:not(.Mui-disabled):before {\n    border-bottom: none;\n}\n\n\n.tournament-phases-fair_play-drop-down__container .MuiInputBase-root {\n    font-family: var(--secondary-font);\n    font-weight: var(--font-medium);\n    font-size: calc(var(--space) + var(--space-eighth) + 1px);\n    line-height: calc(var(--space) + var(--space-quarter) + var(--space-eighth));\n}\n\n.tournament-phases-fair_play-drop-down__container .MuiSelect-select.MuiInputBase-input.MuiInput-input {\n    padding-left: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n}\n\n.tournament-phases-fair_play-drop-down__container .MuiTypography-root {\n    font-weight: var(--font-medium);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .tournament-phases-fair_play-drop-down__container {\n        background: var(--white-color);\n    }\n\n    .tournament-phases-fair_play-drop-down__container .MuiFormControl-root {\n        width: 100%;\n        margin: 12px 10px;\n    }\n    \n    #menu-tournament-phases-fair_play-drop-down__select .MuiPaper-root {\n        left: 12px !important;\n    }\n\n    .tournament-phases-fair_play-drop-down__container .MuiFormControl-root {\n        border-radius: 8px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
